<template>
  <div class="favourites touch">
    <div v-if="pagination.length === 0" class="favourites__empty">
      <div class="favourites__empty-message">
        <p>Unfortunately, you don’t have any favourites added yet.<br>Please explore the properties for sale section in order to add items to your favourites list.</p>
      </div>
    </div>
    <div v-if="pagination.length > 0" class="favourites__list">
      <div
        v-for="(property, i) in pagination"
        :key="property._id"
        class="property"
      >
        <div class="property__inner">
          <div class="property__image" @click="openPropertyListing(i)">
            <img :src="getPropertyThumb(property)">
          </div>
          <div class="property__info">
            <div class="label">{{ property.models[0].label }} - #{{ propertyNumber(property) }}</div>
            <div class="type">{{ property.models[0].type }}</div>
            <div class="remove">
              <button class="btn" @click="removeFromFavourites(property._id)">
                <fa icon="trash-alt"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="numberOfPages > 1" class="pagination">
      <button
        v-for="index in numberOfPages"
        :key="index"
        class="btn"
        :class="{ 'btn--active' : currentPage === index }"
        @click="setCurrentPage(index)"
      >
        {{ index }}
      </button>
    </div>

    <transition name="fast-fade">
      <div v-if="isEmailModalActive" class="favourites__email-modal" @click.stop="closeEmailModal">
        <div class="modal-content" :class="{'modal-content--submitting': isSubmitting}" @click.stop="">
          <div class="modal-content__inner">
            <div class="modal-content__heading">
              Enter your email address
            </div>
            <div class="modal-content__input">
              <input type="email" v-model="email">
            </div>
            <div class="modal-content__submit">
              <button class="btn btn--blue" @click="sendEmail">{{ emailButtonValue }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="''"
      heading="Your Favourites"
      description="Please scan the below QR code on your mobile device to access a copy of your favourites."
      :navigation-items="[]"
    >
      <template v-if="favourites.length > 0" slot="top-slot">
        <qrcode-vue class="qrcode" :value="qrcodeString"></qrcode-vue>
      </template>
      <template slot="top-slot">
      </template>
      <template slot="bottom-slot">
        <button class="btn btn--blue" @click="isEmailModalActive = true">Enter Email</button>
        <button class="right-sidebar__back" @click="$router.go(-1)"><fa icon="chevron-left"/>{{ language.code === 'en' ? 'Back' : 'عودة' }}</button>
      </template>
    </right-sidebar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import RightSidebar from '@/components/RightSidebar'
import QrcodeVue from 'qrcode.vue'
import { uniqBy, find } from 'lodash'
import axios from 'axios'

export default {
  name: 'favourites',

  components: { RightSidebar, QrcodeVue },

  data () {
    return {
      currentPage: 1,
      favouritesPerPage: 6,
      isEmailModalActive: false,
      isError: false,
      isSubmitting: false,
      isSuccess: false,
      email: '',
      message: `<p>Thank you for your interest in purchasing a property at Al Mouj Muscat. Please find below a link to view additional information about the property that we discussed today.</p>`
    }
  },

  computed: {
    ...mapGetters({
      favourites: 'favourites/favourites',
      language: 'language',
      properties: 'property/properties'
    }),

    numberOfPages () {
      if (this.propertyList.length > 0) {
        const pages = Math.ceil(this.propertyList.length / this.favouritesPerPage)
        return pages
      } else {
        return 1
      }
    },

    pagination () {
      let sliceEnd = this.currentPage * this.favouritesPerPage
      const sliceStart = sliceEnd - this.favouritesPerPage
      const allFavourites = this.propertyList
      const favouritesLength = this.propertyList.length

      if (sliceEnd > favouritesLength) {
        sliceEnd = favouritesLength
      }

      const paginatedFavourites = allFavourites.slice(sliceStart, sliceEnd)
      return paginatedFavourites
    },

    propertyList () {
      return uniqBy(this.properties.filter(property => {
        return find(this.favourites, favourite => { 
          return favourite.propertyId === property._id 
        })
      }), '_id')
    },

    propertyIds () {
      return this.propertyList.map(property => property._id).join(',')
    },

    qrcodeString () {
      return `${process.env.VUE_APP_FAVOURITES_HOST}/?r=0&p=${this.favourites.map(favourite => favourite.propertyId)}`
    },

    emailButtonValue () {
      let value = 'Send'

      if (this.isSubmitting) {
        value = 'Sending...'
      }

      if (this.isSuccess) {
        value = 'Sent!'
      }

      if (this.isError) {
        value = 'Failed'
      }

      return value
    }
  },

  methods: {
    getPropertyThumb (property) {
      return this.$store.state.assetsPath + (property.models[0].floorplans[0] || property.models[0].images[0] || property.images[0])
    },

    openPropertyListing (index) {
      const url = `/live/${this.favourites[index].livingId}/subsection/${this.favourites[index].subsectionId}/property/${this.favourites[index].propertyId}`
      this.$router.push(url)
    },

    propertyNumber (property) {
      return property.label.substring(property.label.indexOf('-') + 1)
    },

    removeFromFavourites (propertyId) {
      this.$store.commit('favourites/REMOVE_FROM_FAVOURITES', propertyId)
      
      const propertyLength = this.propertyList.length
      const maxCurrentPage = Math.ceil(propertyLength / this.favouritesPerPage)
      if (this.currentPage > maxCurrentPage) {
        this.currentPage = maxCurrentPage
      }
    },

    setCurrentPage (pageNumber) {
      this.currentPage = pageNumber
    },

    sendEmail () {
      this.isSubmitting = true
      this.isError = false
      this.isSuccess = false

      axios.post(process.env.VUE_APP_API_HOST + '/favourites/shortlist', { 
        email: this.email,
        // senderEmail: this.senderEmail,
        propertyIds: this.propertyIds, 
        message: this.message 
      })
      .then(() => {
        this.isSuccess = true
      })
      .catch(() => {
        this.isError = true
        this.isSuccess = false
      })
      .finally(() => {
        this.isSubmitting = false
        this.email = ''

        setTimeout(() => {
          this.closeEmailModal()
        }, 2000);
      })
    },

    closeEmailModal () {
      this.isSubmitting = false
      this.isError = false
      this.isSuccess = false
      this.email = ''
      this.isEmailModalActive = false
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.favourites {
  background: $white;
  height: 100rem;
  width: 152rem;

  &__empty {
    align-content: center;
    color: $black;
    display: flex;
    height: 100rem;
    justify-content: center;

    &-message {
      font-size: 3rem;
      margin: auto;
      text-align: center;
    }
  }

  &__list {
    color: $black;
    display: flex;
    flex-wrap: wrap;
    height: 80rem;
    padding: 0 5rem;
  }

  &__email-modal {
    background: rgba(0, 0, 0, .7);
    bottom: 8rem;
    left: 0;
    position: absolute;
    right: 40rem;
    top: 0;

    .modal-content {
      background: #fff;
      border-radius: 1rem;
      bottom: 10rem;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      // width: 70rem;

      &--submitting {
        opacity: .7;
        pointer-events: none;
      }

      &__inner {
        padding: 1rem 1.5rem;

        input {
          border: .1rem solid #222;
          border-radius: .5rem;
          padding: .75rem;
          width: 100%;
        }
      }

      &__heading {
        color: #222;
        font-size: 2rem;
        margin: 0 0 1.75rem;
        text-align: center;
      }

      &__submit {
        display: flex;
        justify-content: right;
        margin: .5rem 0 .75rem;

        .btn {
          color: $black;
          font-family: $touchscreen-font;
          font-size: 1.4rem;
          margin: 1rem 0 0;
          padding: 1rem 0 .8rem;
          text-transform: uppercase;
          width: 26rem;

          .ar & {
            font-family: 'GE Dinkum';
          }        

          &--gold {
            @include btn($gold, $gold);
          }

          &--red {
            @include btn($red, $red);
            color: $white;
          }

          &--blue {
            @include btn($ddblue, $ddblue);
            color: $white;
          }
        }
      }
    }
  }

  .property {
    height: 40rem;
    width: calc(100% / 3);

    &__inner {
      border-bottom: .1rem solid rgba($black, 0.1);
      margin: 7.5rem 2.5rem 0;
    }

    &__image {
      height: 24.2rem;
      overflow: hidden;
      width: 100%;

      img {
        object-fit: contain;
        width: 100%;
      }
    }

    &__info {
      margin: 1rem 0;
      position: relative;

      .label {
        font-size: 1.5rem;
        text-transform: capitalize;
      }

      .type {
        font-size: 2rem;
        text-transform: capitalize;
      }

      .remove {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);

        button {
          color: rgba($black, 0.4);
          font-size: 2.2rem;
        }
      }
    }
  }
}

.pagination {
  display: flex;
  height: 20rem;
  justify-content: center;

  .btn {
    background: $dblue;
    border-radius: 50%;
    color: $white;
    font-size: 2rem;
    height: 5rem;
    line-height: 0;
    margin: auto .5rem;
    opacity: .5;
    width: 5rem;

    &--active {
      opacity: 1;
    }
  }
}
</style>
